import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type ImportAssetsMutationVariables = Types.Exact<{
  input: Types.ImportAssetsInput;
}>;


export type ImportAssetsMutation = { __typename?: 'Mutation', importAssets: { __typename?: 'ImportAssetsPayload', id: string, name: string } };


export const ImportAssets = /*#__PURE__*/ gql`
    mutation ImportAssets($input: ImportAssetsInput!) {
  importAssets(input: $input) {
    id
    name
  }
}
    ` as unknown as DocumentNode<ImportAssetsMutation, ImportAssetsMutationVariables>;

          

          export const useImportAssetsMutation = (options?:MutationHookOptions<ImportAssetsMutation, ImportAssetsMutationVariables>) => useMutation(ImportAssets, options);
          

          export type ImportAssetsMutationOptions = MutationHookOptions<ImportAssetsMutation, ImportAssetsMutationVariables>;

          

          export type ImportAssetsMutationResult = ReturnType<typeof useImportAssetsMutation>[1];

          
